import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import copyIconNaivy from '../../static/images/copy-icon-naivy.svg';
import copyIconWhite from '../../static/images/copy-icon-white.svg';
import Clipboard from 'clipboard';

export default class Copy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
      successBlockTimeoutId: null
    };
  }
  componentDidUpdate() {
    let self = this;
    const button = ReactDOM.findDOMNode(this.refs.button);
    if (button && !button._clip) {
      let clipboard = new Clipboard(button);
      button._clip = true;
      clipboard.on('success', function(e) {
        e.clearSelection();
        self.setCopyStatus('success');
      });
      clipboard.on('error', function(e) {
        self.setCopyStatus('error');
      });
    }
  }
  setCopyStatus(status) {
    this.setState({
      status: status
    });
    if (status) {
      this.state.successBlockTimeoutId && clearTimeout(this.state.successBlockTimeoutId);
      this.setState({
        successBlockTimeoutId: setTimeout(() => {this.setCopyStatus(null);}, 3000)
      });
    }
  }
  render() {
    if (!this.props.text) {
      return null;
    } else {
      let {T} = this.props
      return (
        <div>
          <a ref="button" data-clipboard-text={this.props.text} >
              <img src={copyIconNaivy} className="black" alt="copy-icon"/>
              <img src={copyIconWhite} className="white" alt="copy-icon"/>
              <T.text text={"copy.button-text"}/>
          </a>
          {!!this.state.status &&
          <span className="confirm-popup">
            <T.text text={"copy.confirm-popup"}/>
          </span>}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/result/copy.js